/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Button } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import MaterialSymbol from '../../../../components/MaterialSymbol';
import useAppInfo from '../../../../hooks/useAppInfo';
import useToast from '../../../../util/useToast';
import TestIds from '../../../../testIds';

const AppVersion: FC = (): JSX.Element | undefined => {
  const { notify } = useToast();
  const { appInfoString } = useAppInfo();

  const onAppInfoClick = (): void => {
    navigator?.clipboard
      .writeText(appInfoString)
      .then((): void => {
        notify('Details copied to clipboard', {
          type: 'success',
          icon: <MaterialSymbol>inventory</MaterialSymbol>,
        });
      })
      .catch((): void => {
        notify('Copy to clipboard unsuccessful', {
          type: 'error',
          icon: <MaterialSymbol>Error</MaterialSymbol>,
        });
      });
  };

  if (appInfoString) {
    return (
      <Button
        variant='farmlands2.0_typography-small'
        color='secondary'
        onClick={onAppInfoClick}
        data-testid={TestIds.feat.account.userAccount.appVersion.component}
      >
        {appInfoString}
        <ContentCopyOutlinedIcon />
      </Button>
    );
  }
};

export default AppVersion;
